import type { FaireProductEntity } from "../../entity_types/product";

export const p_j8f47677zc: FaireProductEntity = {
  token: "p_j8f47677zc",
  type: "product",
  name: "18K Gold Crystal Herringbone Necklace",
  brandToken: "b_64gjnxjyb8",
  brandName: "Karrbear",
  imageUrl:
    "https://cdn.faire.com/fastly/23839986d4b33cd56f037945e80374ed4185c315b85182b75f0f47055f60705e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2b1e2dbc04f8126726977809f197e8d0817fdef5d1ff29e8aa22e34390cdb439.webp",
  ],
  priceDollars: 13.86,
  description:
    "Elegant Style: This herringbone necklace features a unique pattern of interlocking cubic zirconia crystals that sparkle beautifully for a dressy look.\nPrecious Metal Finish: Crafted from lustrous 18k yellow gold plated, this necklace has a shiny polished surface that resists tarnishing.\nDurable Construction: Each crystal is securely set in the necklace, and the high polish finish makes this piece suitable for everyday wear without worry of damage.\nLength Options Available: Choose from 16, 18, or 20 inches to find the perfect length to complement your neckline and outfit.\nTarnish and Water Resistant: The gold plating protects the sterling silver base and cubic zirconias, allowing this necklace to withstand moisture so you can style it for all occasions.\n",
  tags: [],
  msrpDollars: 27.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:46.829Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
